import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { CommonService } from 'src/app/component/shared/services/common.service';
import { environment } from 'src/environments/environment';
import { COLUMN_LIST, DISPLAY_COLUMN } from '../constants';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-vehicle-data-list',
  templateUrl: './vehicle-data-list.component.html',
  styleUrls: ['./vehicle-data-list.component.scss'],
})
export class VehicleDataListComponent {
  constructor(
    private commonService: CommonService,
    private snackbar: MatSnackBar
  ) {
    this.dataSource = new MatTableDataSource<any>();
    this.dataSource.sortData = this.sortList;
  }

  ngOnInit() {
    this.fetchList();
    const urlAction1 = environment.apiUrl.vehicles + '/listAllVehicleTypes';
    const urlAction2 = environment.apiUrl.vehicles + '/listAllVehicleOwners';
    // this.commonService
    //   .commonPostFullUrlAction(urlAction1, null)
    //   .subscribe(response => {
    //     console.log('response', response);
    //   });
    // this.commonService
    //   .commonPostFullUrlAction(urlAction2, null)
    //   .subscribe(response => {
    //     console.log('response', response);
    //   });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.sort.sort({
      id: 'techVehicleNo',
      start: 'desc',
      disableClear: true,
    });
  }

  isLoading = false;
  isError = false;

  fetchList() {
    if (this.isLoading) return;
    const urlAction = environment.apiUrl.vehicles + '/listAllVehicles';
    this.commonService.commonPostFullUrlAction(urlAction, null).subscribe({
      next: response => {
        console.log('vehicles: ', response);
        if (response?.length > 0) {
          this.dataSource.data = response;
        } else {
          this.snackbar.open('No vehicles found.', null, {
            duration: 5000,
          });
        }
        this.isLoading = false;
      },
      error: err => {
        console.log('Error Vehicles List:', err);
        this.snackbar.open(
          'Failed to fetch vehicles. Please refresh the page and try again.',
          null,
          {
            duration: 5000,
            panelClass: 'custom-snack-bar-panel-error',
          }
        );
        this.reset();
        this.isLoading = false;
      },
    });
  }

  reset() {
    this.dataSource.data = [];
  }

  dataSource;
  displayedColumns = DISPLAY_COLUMN;
  columnList = COLUMN_LIST;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  /** Sort and Filter Functions */
  sortList(records: any[], sort: MatSort): any[] {
    const { active, direction } = sort;
    if (!active || direction === '') {
      return records;
    }
    return records.sort((a: any, b: any) => {
      let comparisonResult = 0;
      switch (active) {
        default:
          comparisonResult = a[active].localeCompare(b[active]);
      }
      return comparisonResult * (direction === 'asc' ? 1 : -1);
    });
  }
}
